import React, { useState, useEffect } from 'react'
import { useMsal } from '@azure/msal-react'
import { useNavigate } from 'react-router-dom'
import { TailSpin } from 'react-loader-spinner'
import { LocalStorageService } from '../../CoreComponents/constants/service/LocalStorageService'
import { message } from 'antd'
import { inkapi } from '../../middleware/interceptor'
import axios from "axios";

export const SSOSignin = ({ isAuthenticated, setEmp_Role, Emp_Role }) => {
  const { instance } = useMsal()
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const [messageApi, contextHolder] = message.useMessage()

  const success = msg => {
    messageApi.open({
      type: 'success',
      title: 'Success',
      content: msg,
      duration: 1.5
    })
  }

  const error = () => {
    messageApi.open({
      type: 'error',
      duration: 2,
      content: 'Error While  Login!'
    })
  }

  const Loader = <TailSpin visible={true} height='30' width='50' radius='1' />

  const handleSignInWithMicrosoft = async () => {
    // setIsLoading(true)
    // instance.loginRedirect({
    //   scopes: ['user.read']
    // })

    const CLIENT_ID = `623155047831-5kul72s5ij92bo0ht3r9q8b6rk9330k0.apps.googleusercontent.com`
    const REDIRECT_URL = `https://app.theinkscribe.com`;
    const STATE = encodeURIComponent('/All-Data');
    const googleAuthUrl = `https://accounts.google.com/o/oauth2/v2/auth?response_type=token&client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URL}&scope=openid%20email%20profile&state=${STATE}`;
    window.location.href = googleAuthUrl;

  }


  const extractTokenFromUrl = () => {
    const hash = window.location.hash;

    if (hash) {
      const params = new URLSearchParams(hash.substring(1));
      const accessToken = params.get('access_token');
      const state = params.get('state');

      localStorage.setItem("google_token", accessToken);

      if (accessToken) {
        getGoogleAccessToken(accessToken)
      } else {
        console.error('No access token found in URL');
      }
      window.history.replaceState(null, null, state || '/');
    }
  };

  const getGoogleAccessToken = (accessToken) => {
    setIsLoading(true);
    axios
      .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${accessToken}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json'
        }
      })
      .then(async (res) => {
        const data = res.data;
        const payload = {
          username: `${data.given_name}${data.family_name}`,
          email: data.email,
          authType: "Google-SSO"
        }
        sessionStorage.setItem('UserName', `${data.email}`);
        sessionStorage.setItem('AdminLogin', JSON.stringify(true));
        setIsLoading(false);
        navigate('/dashboard');
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    extractTokenFromUrl();
  }, []);


  return (
    <div>
      {contextHolder}
      <div className='h-screen grid grid-cols-2'>
        <div className='flex justify-center items-center md:flex'>
          <img
            className='w-full h-full object-cover'
            src='/book.jpg'
            alt='signin'
          />
        </div>
        <div className='bg-blue-100 flex flex-col gap-6 justify-center items-center p-10 sm:p-12.5 xl:p-17.5'>
          <img className='max-w-[20rem]' src='ink_logo-banner.png' />
          {isLoading ? (
            Loader
          ) : (
            <button
              style={{ backgroundColor: 'rgb(27, 20, 51)' }} // Use inline style
              className='w-full text-white justify-center px-5 py-5 signin-btn rounded-md flex gap-5 items-center'
              onClick={handleSignInWithMicrosoft}
            >
              <img
                src="./google-logo.png"
                alt="google logo"
                style={{ width: '1.5em', marginRight: '0.5em' }}
              />
              Sign in with Google
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
